module.exports = __webpack_public_path__ + "static/img/n-command.3c859212.png";